__turbopack_context__.v({
  "copied": "textCopy-module-scss-module__kfy63W__copied",
  "copiedWrapper": "textCopy-module-scss-module__kfy63W__copiedWrapper",
  "custom": "textCopy-module-scss-module__kfy63W__custom",
  "default": "textCopy-module-scss-module__kfy63W__default",
  "duplicateIcon": "textCopy-module-scss-module__kfy63W__duplicateIcon",
  "isLoading": "textCopy-module-scss-module__kfy63W__isLoading",
  "text": "textCopy-module-scss-module__kfy63W__text",
  "wrapper": "textCopy-module-scss-module__kfy63W__wrapper",
});
